import React from 'react';
import {
  Box,
  Text,
  Tag,
  TagLabel,
  TagCloseButton,
  HStack,
  VStack,
  Button,
} from '@chakra-ui/react';
import { FiList } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import { ShowProductModalInfo } from 'components/Product/Product.ModalInfo';
import { ProductParams } from 'store/products';

export function MarketCart({
  products,
  onRemoveProduct,
  onClearAll,
}: {
  products: ProductParams[];
  onRemoveProduct: (id: number) => void;
  onClearAll: () => void;
}): JSX.Element | null {
  const { t } = useTranslation();

  if (products.length === 0) return null;

  return (
    <Box
      bg='blue.100'
      p={4}
      mb={4}
      borderRadius='md'
      border='1px solid'
      borderColor='blue.200'
      _dark={{ bg: 'blue.900', borderColor: 'blue.700' }}
      maxW='1241px'
      position='fixed'
      bottom={2}
      zIndex={1}
    >
      <VStack spacing={2} align='start' wrap='wrap'>
        <HStack mb={2}>
          <FiList />
          <Text fontWeight='bold'>
            {t(
              'market.productsAddedToCampaign',
              'Produkty dodane do kampanii ({{count}})',
              { count: products.length },
            )}
          </Text>
          <Button onClick={onClearAll} variant='ghost' size='xs'>
            {t('market.clearAll', 'Wyczyść wszystko')}
          </Button>
        </HStack>

        <HStack spacing={0} gap={2} wrap='wrap'>
          {products.map(product => (
            <Tag
              size='md'
              key={product.id}
              borderRadius='full'
              variant='solid'
              colorScheme='blue'
              borderColor='nexusTeal.100'
              borderWidth='1px'
              ml={0}
            >
              <TagLabel>
                {' '}
                <ShowProductModalInfo
                  text={product.generalValue.name}
                  product={product}
                  linkStyle={{
                    color: 'white.200',
                    _hover: { color: 'whiteAlpha.700' },
                  }}
                />
              </TagLabel>
              <TagCloseButton
                color='white.500'
                onClick={() => onRemoveProduct(product.id)}
              />
            </Tag>
          ))}
        </HStack>
      </VStack>
    </Box>
  );
}
